import React, { useState } from 'react';
import { Modal, Box, Typography, Button, TextField } from '@mui/material';
import Cookies from 'js-cookie';
import { AxiosError, AxiosRequestConfig } from 'axios';
import { toast } from 'react-toastify';
import { api } from '../../../../shared/services/api';
import moment from 'moment';

interface ModalGenerateShipmentProps {
  open: boolean;
  closeModal: (shouldReload?: boolean) => void;
}

const ModalGenerateShipment: React.FC<ModalGenerateShipmentProps> = ({
  open,
  closeModal,
}) => {
  const token = Cookies.get('@token');
  const [generateIsLoading, setGenerateIsLoading] = useState(false);
  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedDate(event.target.value);
  };

  const handleGenerateArchive = async () => {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
      responseType: 'blob',
    };

    setGenerateIsLoading(true);
    try {
      const formattedDate = moment(selectedDate).format('DDMMYYYY');

      const responseGenerateDetailPerson = await api.get(
        `/archive/response-ajud/${formattedDate}`,
        config,
      );

      if (responseGenerateDetailPerson.status === 200) {
        // Crie o arquivo de texto

        const fileContent = responseGenerateDetailPerson.data;
        const textBlob = new Blob([fileContent], { type: 'text/plain' });
        // Crie um arquivo zip
        const zipFileName = `ajud302-${selectedDate}.zip`;
        const zipBlob = new Blob([textBlob], { type: 'application/zip' });
        // Crie a URL para o arquivo zip e inicie o download
        const zipUrl = window.URL.createObjectURL(zipBlob);
        const link = document.createElement('a');
        link.href = zipUrl;
        link.setAttribute('download', zipFileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success('Arquivo gerado com sucesso');
      }
    } catch (err: unknown) {
      if (err instanceof AxiosError) {
        const errorMessage = err.response?.data?.message || 'Erro de conexão';
        toast.error(errorMessage);
      } else {
        toast.error('Erro inesperado');
      }
    } finally {
      setGenerateIsLoading(false);
    }
    setGenerateIsLoading(false);
    handleClose(true);
  };

  const resetStates = () => {
    setSelectedDate('');
  };

  const handleClose = (shouldReload?: boolean) => {
    resetStates();
    closeModal(shouldReload);
  };

  const [selectedDate, setSelectedDate] = useState('');
  return (
    <Modal open={open} onClose={() => handleClose(true)}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '400px',
          bgcolor: 'background.paper',
          borderRadius: 2,
          p: 4,
          boxShadow: 24,
        }}
      >
        <Typography variant="h6" gutterBottom>
          Gerar Remessa de Bloqueio
        </Typography>
        <TextField
          label="Selecione uma data"
          type="date"
          value={selectedDate}
          onChange={handleDateChange}
          InputLabelProps={{
            shrink: true, // Mantém o label acima do input
          }}
          fullWidth
        />
        <Typography variant="body1" gutterBottom>
          Confirma a geração da remessa?
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
          <Button
            variant="contained"
            disabled={selectedDate == '' || generateIsLoading}
            color="primary"
            onClick={() => handleGenerateArchive()}
          >
            Confirmar
          </Button>
          <Button
            variant="outlined"
            color="error"
            onClick={() => handleClose(false)}
          >
            Cancelar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalGenerateShipment;
